// 事件总线事件名常量——集中管理，避免字符串拼写错误导致静默失败
export const BusEvents = {
  YY_CHATBOT_CALL: 'yyChatbotCall',
  SHOW_AI_CHATBOT: 'showAiChatbot',
  HIDE_AI_CHATBOT: 'hideAiChatbot',
};
